import type { ColDef, ColGroupDef } from 'ag-grid-community';
import type { RefObject } from 'react';

import { AgGridCellTooltipComponent, AgGridCellTooltipValueGetter } from '../AgGridCellTooltipComponent';
import { suppressKeyboardEventForInput } from '../utils';

export const defaultColDef = {
    resizable: true,
    wrapHeaderText: true,
    sortable: false,
    suppressKeyboardEvent: suppressKeyboardEventForInput,
};

export const getColumnsWithTooltip = <T = any>(
    cols: (ColDef<T> | ColGroupDef<T>)[] | undefined | null,
): (ColDef<T> | ColGroupDef<T>)[] => {
    if (!cols) {
        return [];
    }

    return cols.map((c) => {
        if ('tooltipComponent' in c) {
            return c;
        }

        let child;

        if ('children' in c && c.children) {
            child = getColumnsWithTooltip(c.children);
        }

        return {
            ...c,
            tooltipComponent: AgGridCellTooltipComponent,
            tooltipValueGetter: AgGridCellTooltipValueGetter({}),
            ...(child && { children: child }),
        };
    });
};

export const getFilterActiveIcon = (
    currentColId: string | undefined,
    isActive: boolean,
    elRef: RefObject<HTMLDivElement>,
) => {
    const tableWrapper = elRef?.current;
    const el = tableWrapper?.querySelector(`[col-id="${currentColId}"]`);
    const node = el?.querySelector<HTMLElement>('.ag-header-icon.ag-header-cell-filter-button');

    if (node && tableWrapper) {
        if (isActive) {
            node.style.opacity = '1';
        } else {
            node.style.removeProperty('opacity');
        }
    }
};
